/**
 * Lienzo de widgets del Inicio: los tableros del cargo (CIMS0037 →
 * catálogo CIMS0036) con la MISMA tarjeta que Mi escritorio (Tarjewid del
 * kit): cabecera con el nombre, tamaño S/M/L y widget montado por lazy
 * import desde su ruta del catálogo. Registrar un widget es un INSERT en
 * la parametría; el front no opina (FASE 5, root/cimaapi#355).
 * @author Diego Serrano <diego.serrano@repremundo.com.co>
 * @since 2026-09-14
 * @param {Array} graphs  Filas del catálogo del cargo (con GRARUTAX)
 * @param {object} refs   Refs por GRACOMXX para desplazarse a un widget (opcional)
 */
import React from "react";
import Tarjewid from "../../Tablerox/Tarjewid";

export function Bugraphs({ graphs, refs = {} }) {
  const widgets = (graphs ?? []).filter((graph) => graph?.GRARUTAX);
  return (
    <div style={{ display: "flex", flexWrap: "wrap", gap: "1%", rowGap: 12 }}>
      {widgets.map((widget) => (
        <Tarjewid key={widget.GRAIDXXX} widget={widget} refTarjeta={refs[widget.GRACOMXX] ?? null} />
      ))}
    </div>
  );
}

export default Bugraphs;
